import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
import { getMUICache, } from '../../../common/utils';
import './ContentRestrictionsTwo.css';

ContentRestrictionsTwo.version = 1000;

ContentRestrictionsTwo.lang = 'en';
ContentRestrictionsTwo.langs = [
    'en'
];
ContentRestrictionsTwo.setLang = (lang: any) => {
    ContentRestrictionsTwo.lang = lang;
}

Object.defineProperty(ContentRestrictionsTwo, 'name', {
    writable: true,
    value: 'ContentRestrictionsTwo'
});


export function ContentRestrictionsTwo(props: any) {
    const {ContentRestrictions } = props;
    // console.log('ContentRestrictions toggle value:', ContentRestrictions);
    const cache = getMUICache();

    return (
        <CacheProvider value={cache}>
            <Grid item md={12} xs={12}>
                <div className='contentRestrictionWrapper'>
                    <div className='contentRestrictionHeadingWrap'>
                        <div className='contentRestrictionHeading'>CONTENT RESTRICTION</div>
                    </div>
                    <div className='contentRestrictionText'>
                        <p>This content is not accessible in your country</p>

                    </div>

                    {ContentRestrictions && (
                         <div className='contentRestrictionImageWrapper'>
                        {/* <picture>
                            <source media="(min-width: 320px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 124, '', authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS)} />      
                                <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 205, '', authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS)} />
                                <img alt={authorData?.name} title={authorData?.name} loading="lazy" />
                            </picture> */}
                            <img src ="https://staticimg.publishstory.co/stresources/images/content-restriction.png"/>                    
                            </div>
                    )}
                   
                </div>
            </Grid>
        </CacheProvider>

    )

}
